import { IRequest } from '@r1-frontend/shared/types/IRequest';

/*
* Получение цен
* https://master.ppd.sandbox.d2c.r-one.io/docs/#/ppd-prices/PpdPricesController_getPpdPricesByProvider
*/
export const getPpdPrices = (providerId: number): IRequest => ({
    uri: `api/v1/${providerId}/ppd-prices`,
    method: 'GET',
    withProvider: true,
});

/*
* Получение одной цены
* https://master.ppd.sandbox.d2c.r-one.io/docs/#/ppd-prices/PpdPricesController_getPpdPriceById
*/
export const getPpdPrice = (id: number): IRequest => ({
    uri: `api/v1/ppd-prices/${id}`,
    method: 'GET',
});
